import React, { useEffect, FC } from "react";
import { useParams } from "react-router";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { selectCurrentUser } from "src/redux/currentUser/selector";
import { selectorChat } from "src/redux/chat/selector";
import { getChatAsync } from "src/redux/chat/actions";
import { ChatWindow } from "src/page-components/cabinet/chat/[id]/ChatWindow";
import { MetadataWrapper } from "src/components/MetadataWrapper";
import { CABINET_DATA } from "src/page-components/cabinet/constants";
import { chatTrns, metaTrns } from "src/page-components/cabinet/chat/trns";
import { PageWrapper } from "src/components/Layouts/PageWrapper";
import { Loader } from "src/components/Loader";
import { NavigationSidebar } from "src/components/NavigationSidebar";
import { Sizes } from "src/@types/sizes";

const ChatItem: FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const user = useAppSelector(selectCurrentUser);
  const currentChat = useAppSelector(selectorChat);

  const { id } = useParams();

  useEffect(() => {
    dispatch(getChatAsync({ id }));
  }, [dispatch, id]);

  // CHANGE
  if (!currentChat.data && !currentChat.isLoading) {
    return null;
  }

  if (!user) return null;

  const { sidebarItems } = CABINET_DATA[user.host.role];

  const metaName = currentChat.data?.seller?.company_name;

  return (
    <MetadataWrapper
      title={t(metaTrns.title, {
        name: metaName,
      })}
      description={t(metaTrns.description, {
        name: metaName,
      })}
    >
      <PageWrapper mainClassName="py-25">
        {currentChat.isLoading ? (
          <div className="flex justify-center items-center min-h-72">
            <Loader size={Sizes.XXL} />
          </div>
        ) : (
          <section className="container flex flex-col gap-2 xl:gap-10">
            <h1 className="font-semibold">{t(chatTrns.title)}</h1>

            <div className="xl:flex items-start gap-5">
              <NavigationSidebar
                className="xl:min-w-73.5"
                sidebarItemClassName="!justify-start px-5 py-3"
                items={sidebarItems}
              />
              <ChatWindow chat={currentChat.data} />
            </div>
          </section>
        )}
      </PageWrapper>
    </MetadataWrapper>
  );
};

export default ChatItem;
